module.exports = __webpack_public_path__ + "img/couples-071.37ee5031.jpg";